"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContainer = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../layout");

var _context = require("../context");

var _filterObject = require("../utils/filterObject");

var _core = require("@emotion/core");

var PageContainerBase = function PageContainerBase(containerProps) {
  return (0, _core.jsx)(_context.StencilConsumer, null, function (_ref) {
    var selectors = _ref.selectors;
    return (0, _core.jsx)(_layout.Container, (0, _extends2.default)({
      paddingHorizontal: selectors.constant('pageHorizontalPadding')
    }, containerProps));
  });
};

PageContainerBase.defaultProps = (0, _objectSpread2.default)({}, (0, _filterObject.omit)(_layout.Container.defaultProps, ['paddingHorizontal']), {
  paddingTop: 'S600',
  paddingBottom: 'S700',
  dataTestId: 'StencilReactPageContainer'
});
var PageContainer = (0, _stencilReactDesc.describe)(PageContainerBase).description('Page container with consistent padding and maximum width.');
exports.PageContainer = PageContainer;
PageContainer.displayName = 'PageContainer';
PageContainer.propTypes = (0, _objectSpread2.default)({}, _layout.Container.describedPropTypes);